var finance = {
     investments : [
        {
            name:"Tesouro direto",
            interestRate :0.0757,
        },        
        {
            name:"Poupança",
            interestRate :0.014,
        }

    ],


    loanPayment( loan,  interestRate, numberOfPayments   ){
        if(interestRate == 0.0)
            return (loan / numberOfPayments);
        if(numberOfPayments <=1)
            return loan;
        return ( (loan * interestRate) /    (   1.0 - Math.pow(    1.0 + interestRate , numberOfPayments*-1.0  ) )   )
     },
     
     //If there's no loan use loanInterestRafe
     
     investmentCashFlow( invesmentCost,  upFrontInvesment, numberOfPayments, loanInterestRatePercent , inflationRatePercent , monthlySavings  ){
        //( 100000 , 10000, 60, 0.05 , 0.1, 500  );
        var loanInterestRate = loanInterestRatePercent / 100.0;
        var inflationRate = inflationRatePercent / 100.0;

        var years = [];
        var loan = invesmentCost - upFrontInvesment;
        var loanPayment = this.loanPayment(loan , loanInterestRate , numberOfPayments   )
        
        console.log( JSON.stringify( { loanPayment})  )
        //var balance =       
        var amortizationAmount = numberOfPayments * loanPayment;// - upFrontInvesment;
        console.log( JSON.stringify( { amortizationAmount})  )
        //var balance = [];
        //var years = []

        var cashFlow = []; // { year: , balance: , annualSavings : , annualPayment   }
        var annualSavings = monthlySavings *12;
        var year = 0 ;
        var annualPayment = loanPayment *12;
        var endingBalance= 0.0;

        console.log( JSON.stringify( { annualPayment})  )

        if(annualPayment >= amortizationAmount )
            annualPayment = amortizationAmount ;
        
        endingBalance =  -annualPayment  - upFrontInvesment + annualSavings;
        
        //Year 0
        var item = { year , endingBalance, annualSavings , amortizationAmount  ,annualPayment  }
        amortizationAmount = amortizationAmount- annualPayment;
        
        cashFlow.push(item);

        console.log("first amortization ammount")
        console.log( JSON.stringify( { amortizationAmount})  )

        for ( year = 1 ; year <= 29 ; year++ ){
            if(amortizationAmount > 0.0){
                if( annualPayment >= amortizationAmount )
                    annualPayment = amortizationAmount;
            }
            if( amortizationAmount<= 0.0)
                annualPayment = 0.0;
            
            console.log( JSON.stringify( { amortizationAmount})  )    
                
            annualSavings = monthlySavings * 12 * Math.pow (1 + inflationRate ,year )
            
            endingBalance = endingBalance + annualSavings - annualPayment;
            
            item =  { year , endingBalance, annualSavings , amortizationAmount  ,annualPayment  }
            cashFlow.push(item);
            amortizationAmount -= annualPayment;
            


        }
        return cashFlow;
     },

     //annualProduction is an array calculated outside
     investmentCashFlow2( invesmentCost,  upFrontInvesment, numberOfPayments, loanInterestRatePercent , inflationRatePercent , annualProduction, energyPriceBase, annualConsumption , annualMinAmount  ,modulePerformance ){
        console.log("investmentCashFlow2")
        console.log("annualProduction:" + JSON.stringify(annualProduction))

        console.log("energyPriceBase: " + JSON.stringify({energyPriceBase}))

        
        
        //( 100000 , 10000, 60, 0.05 , 0.1, 500  );
        var loanInterestRate = loanInterestRatePercent / 100.0;
        var inflationRate = inflationRatePercent / 100.0;
        var monthlySavings = 0; 
        var energyPrice = energyPriceBase;

        var years = [];
        var loan = invesmentCost - upFrontInvesment;
        var loanPayment = this.loanPayment(loan , loanInterestRate , numberOfPayments   )
        
        console.log( JSON.stringify( { loanPayment})  )
        //var balance =       
        var amortizationAmount = numberOfPayments * loanPayment;// - upFrontInvesment;
        console.log( JSON.stringify( { amortizationAmount})  )
        //var balance = [];
        //var years = []

        var cashFlow = []; // { year: , balance: , annualSavings : , annualPayment   }

        var newAnnualConsumption  = 0;
        var energyCreditBalance = 0 ;
        
        energyCreditBalance =annualProduction[0];

        if(energyCreditBalance  <= annualConsumption - annualMinAmount){
            newAnnualConsumption = annualConsumption  - energyCreditBalance;
            energyCreditBalance = 0;
        }else{
            newAnnualConsumption = annualMinAmount;  
            energyCreditBalance = energyCreditBalance - (annualConsumption - annualMinAmount)
        }
        


        var annualSavings = (annualConsumption - newAnnualConsumption) * energyPrice;
        
        //var annualSavings = annualProduction[0] * energyPrice;
        var year = 0 ;
        var annualPayment = loanPayment *12;
        var endingBalance= 0.0;

        if(annualPayment >= amortizationAmount )
            annualPayment = amortizationAmount ;
        
        endingBalance =  -annualPayment  - upFrontInvesment + annualSavings;
        
        //Year 0
        var item = { year , endingBalance, annualSavings , amortizationAmount  ,annualPayment , annualProduction: annualProduction[0], annualConsumption,  newAnnualConsumption, energyCreditBalance, modulePerformance:modulePerformance[0]  }
        amortizationAmount = amortizationAmount- annualPayment;
        
        cashFlow.push(item);

        console.log("first amortization ammount")
        console.log( JSON.stringify( { amortizationAmount})  )

        for ( year = 1 ; year <= 29 ; year++ ){
            if(amortizationAmount > 0.0){
                if( annualPayment >= amortizationAmount )
                    annualPayment = amortizationAmount;
            }
            if( amortizationAmount<= 0.0)
                annualPayment = 0.0;
            
            console.log( JSON.stringify( { amortizationAmount})  )    
            
            energyPrice = energyPriceBase * Math.pow (1 + inflationRate ,year );


            
            energyCreditBalance += annualProduction[year];
            if(energyCreditBalance  <= annualConsumption - annualMinAmount){
                newAnnualConsumption = annualConsumption  - energyCreditBalance;
                energyCreditBalance = 0;
            }else{
                newAnnualConsumption = annualMinAmount;  
                energyCreditBalance = energyCreditBalance - (annualConsumption - annualMinAmount)
            }

            //annualSavings = annualProduction[year] * energyPrice;                             
            annualSavings = (annualConsumption  - newAnnualConsumption) * energyPrice;                             
            
            endingBalance = endingBalance + annualSavings - annualPayment;
            
            item =  { year , endingBalance, annualSavings , amortizationAmount  ,annualPayment , annualProduction: annualProduction[year], annualConsumption,  newAnnualConsumption, energyCreditBalance , modulePerformance:modulePerformance[year]}
            cashFlow.push(item);
            amortizationAmount -= annualPayment;
            


        }
        return cashFlow;
     }
     
  

}

export default finance;
